import React from "react";

export default function TermsOfService() {
  return (
    <div className="legal-page">
      <h1>Terms of Service</h1>

      <p>
        By using this website, you agree to the following terms and conditions.
      </p>

      <h2>Use of Website</h2>
      <p>
        You agree to use this site only for learning and course-related purposes.
      </p>

      <h2>Course Content</h2>
      <p>
        All course materials are for educational use only and cannot be resold.
      </p>

      <h2>Changes</h2>
      <p>
        We may update these terms at any time without prior notice.
      </p>
    </div>
  );
}